import { useEffect, useState } from "react";
import { Sprout } from "lucide-react";
import { estimateRootForAmount, getEarnRate, DEFAULT_EARN_RATE_PER_XCD } from "@/lib/rootRewards";

interface RootEarnBadgeProps {
  /** XCD amount the ROOT estimate is based on. */
  amountXcd: number;
  /** Optional fixed ROOT override (e.g. product metadata). */
  fixedRoots?: number;
  className?: string;
  /** "purchase" | "order" wording variant. */
  context?: "product" | "cart";
}

/**
 * Shows an estimated ROOT earning preview.
 * ROOT is the participation and rewards unit of the Sugar Town Organics ecosystem.
 */
const RootEarnBadge = ({ amountXcd, fixedRoots, className = "", context = "product" }: RootEarnBadgeProps) => {
  const [rate, setRate] = useState<number>(DEFAULT_EARN_RATE_PER_XCD);

  useEffect(() => {
    let active = true;
    getEarnRate().then((r) => {
      if (active) setRate(r);
    });
    return () => {
      active = false;
    };
  }, []);

  const roots = fixedRoots ?? estimateRootForAmount(amountXcd, rate);
  if (roots <= 0) return null;

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/5 px-3 py-1.5 text-sm font-sans text-primary ${className}`}
    >
      <Sprout className="h-4 w-4 shrink-0" />
      <span>
        {context === "cart" ? "Earn" : "Earn"}{" "}
        <strong>{roots.toLocaleString()} ROOT</strong>{" "}
        {context === "cart" ? "with this order" : "with this purchase"}
      </span>
    </div>
  );
};

export default RootEarnBadge;
